import Box from "@mui/material/Box";
import "./StatusChip.css";

const StatusChip = ({ content, type = "done" }) => {
  return <Box className={`status-chip status-chip--${type}`}>{content}</Box>;
};

export default StatusChip;
